import { ref, computed } from "vue";
import { BottomSheetTransitions, BottomSheetType } from "../const/types.mjs";
import { useState } from "#app";
const aliases = ref(
  {}
);
export function useBottomSheet() {
  const activeBottomSheet = useState("active-bottom-sheet", () => null);
  const activeAlias = computed(() => {
    return Object.keys(aliases.value).find((alias) => {
      return activeBottomSheet.value?.id && aliases.value[alias]?.id && aliases.value[alias]?.id === activeBottomSheet.value?.id;
    });
  });
  function getRandomID() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
  function openBottomSheet(sheet, props) {
    activeBottomSheet.value = {
      sheet,
      id: getRandomID(),
      props
    };
  }
  function openAliasBottomSheet(props, sheetProps) {
    activeBottomSheet.value = {
      sheet: props.sheet,
      id: props.id,
      props: sheetProps
    };
  }
  function closeBottomSheet() {
    activeBottomSheet.value = null;
  }
  function defineAliases(inputs) {
    Object.entries(inputs).forEach(([key, value]) => {
      aliases.value[key] = { component: value, id: getRandomID() };
    });
  }
  function openDefinedAlias(alias, type = BottomSheetType.DEFAULT, animationType = BottomSheetTransitions.BOTTOM_UP, props) {
    const component = aliases.value[alias];
    if (component) {
      openAliasBottomSheet({
        id: component.id,
        sheet: {
          type,
          component: component.component,
          animationType
        }
      }, props);
    }
  }
  function closeDefinedAlias(alias) {
    const component = aliases.value[alias];
    if (component) {
      closeBottomSheet();
    }
  }
  function toggleDefinedAlias(alias, type = BottomSheetType.DEFAULT, animationType = BottomSheetTransitions.BOTTOM_UP, props) {
    if (!aliases.value[alias])
      throw new Error(`Alias ${alias} is not defined`);
    if (activeAlias.value !== alias) {
      closeBottomSheet();
    }
    const component = aliases.value[alias];
    if (component) {
      if (activeBottomSheet.value) {
        closeBottomSheet();
      } else {
        openDefinedAlias(alias, type, animationType, props);
      }
    }
  }
  return {
    activeBottomSheet,
    closeBottomSheet,
    openBottomSheet,
    defineAliases,
    openDefinedAlias,
    closeDefinedAlias,
    toggleDefinedAlias,
    activeAlias
  };
}
